import { useState, useEffect, useCallback, useContext } from "react";
import { TextField, Grid, InputAdornment } from "@mui/material";

import "./employerSection.css";

const EmployerSection = () => {
	return (
		<div className="employer-section-container" id="employer-section-container">
			<div className="employer-form-header" id="employer-form-header">
				Employer Completes this Section.
			</div>
			<div className="billing-division" id="billing-division">
				<span className="heading-label">Billing Division or Location: </span>
				<span className="textfield-container" id="textfield-container">
					<TextField
						className="text-field"
						id="text-field"
						variant="standard"
						name="billing_division"
						style={{
							width: "81.7%",
							borderRadius: 50
						}}
					/>
				</span>
			</div>
			<div className="group-cycle-container" id="group-cycle-container">
				<Grid container spacing={1}>
					<Grid item xs={8} sm={8} md={8} lg={8} xl={8} className="sort-group">
						<span className="heading-label">Sort Group/Code: </span>
						<span className="textfield-container" id="textfield-container">
							<TextField
								className="text-field"
								id="text-field"
								variant="standard"
								name="sort_code"
								style={{
									width: "79%",
									borderRadius: 50
								}}
							/>
						</span>
					</Grid>
					<Grid item xs={4} sm={4} md={4} lg={4} xl={4} className="payroll-cycle">
						<span className="heading-label">Payroll Cycle: </span>
						<span className="textfield-container" id="textfield-container">
							<TextField
								className="text-field"
								id="text-field"
								variant="standard"
								name="payroll_cycle"
								style={{
									width: "65.5%",
									borderRadius: 50
								}}
							/>
						</span>
					</Grid>
				</Grid>
			</div>
			<div className="policy-container" id="policy-container">
				<span className="heading-label">Policy #(s): </span>
				<span className="textfield-container" id="textfield-container">
					<TextField
						className="text-field"
						id="text-field"
						variant="standard"
						name="policy"
						style={{
							width: "90%",
							borderRadius: 50
						}}
					/>
				</span>
			</div>
			<div className="average-occupation-container" id="average-occupation-container">
				<Grid container spacing={1}>
					<Grid item xs={8} sm={8} md={8} lg={8} xl={8} className="average-hours">
						<span className="heading-label">Average Hours Worked Per Week: </span>
						<span className="textfield-container" id="textfield-container">
							<TextField
								className="text-field"
								id="text-field"
								variant="standard"
								name="average_hours"
								style={{
									// width: "90.3%",
									borderRadius: 50
								}}
							/>
						</span>
						<span className="full-time-checkbox">
							<input type="checkbox" id="full-time" name="full_time" value="full_time" /> {" "}
							<label htmlFor="full_time">Full-time</label>
						</span>
						<span className="part-time-checkbox">
							<input type="checkbox" id="part-time" name="part_time" value="part_time" /> {" "}
							<label htmlFor="part_time">Part-time</label>
						</span>
					</Grid>
					<Grid item xs={4} sm={4} md={4} lg={4} xl={4} className="occupation-container">
						<span className="heading-label">Occupation: </span>
						<span className="textfield-container" id="textfield-container">
							<TextField
								className="text-field"
								id="text-field"
								variant="standard"
								name="occupation"
								style={{
									width: "68.1%",
									borderRadius: 50
								}}
							/>
						</span>
					</Grid>
				</Grid>
			</div>
			<div className="earnings-container" id="earnings-container">
				<Grid container spacing={1}>
					<Grid item xs={8} sm={8} md={8} lg={8} xl={8} className="earnings-container">
						<span className="heading-label">Earnings: </span>
						<span className="hourly-radio-field">
							<input type="checkbox" id="hourly" name="hourly" value="hourly" /> {" "}
							<label htmlFor="hourly">Hourly</label>
						</span>
						<span className="weekly-radio-field">
							<input type="checkbox" id="weekly" name="weekly" value="weekly" /> {" "}
							<label htmlFor="weekly">Weekly</label>
						</span>
						<span className="monthly-radio-field">
							<input type="checkbox" id="monthly" name="monthly" value="monthly" /> {" "}
							<label htmlFor="monthly">Monthly</label>
						</span>
						<span className="yearly-radio-field">
							<input type="checkbox" id="yearly" name="yearly" value="yearly" /> {" "}
							<label htmlFor="yearly">Yearly</label>
						</span>
						<span className="textfield-container" id="textfield-container">
							<TextField
								className="text-field"
								id="text-field"
								variant="standard"
								name="earnings_value"
								InputProps={{
									startAdornment: <InputAdornment position="start">$</InputAdornment>
								}}
								style={{
									width: "25%",
									borderRadius: 50
								}}
							/>
						</span>
					</Grid>
					<Grid item xs={4} sm={4} md={4} lg={4} xl={4} className="employment-container">
						<span className="heading-label">Date of Employment: </span>
						<span className="textfield-container">
							<TextField
								className="date-field"
								id="text-field"
								variant="standard"
								placeholder="MM"
								name="month"
								style={{
									width: "30px",
									borderRadius: 50
								}}
							/>
						</span>
						/
						<span className="textfield-container">
							<TextField
								className="date-field"
								id="text-field"
								variant="standard"
								placeholder="DD"
								name="day"
								style={{
									marginLeft: "3px",
									width: "30px",
									borderRadius: 50
								}}
							/>
						</span>
						/
						<span className="textfield-container">
							<TextField
								className="date-field"
								id="text-field"
								variant="standard"
								placeholder="YYYY"
								name="year"
								style={{
									marginLeft: "3px",
									width: "50px",
									borderRadius: 50
								}}
							/>
						</span>
					</Grid>
				</Grid>
			</div>
			<div className="active-work-container" id="active-work-container">
				<Grid container spacing={1}>
					<Grid item xs={8} sm={8} md={8} lg={8} xl={8} className="active-work-sub-container">
						<span className="heading-label">Actively at work? </span>
						<span className="active-work-yes-radio-field">
							<input type="checkbox" id="yes" name="yes" value="yes" />  <label htmlFor="yes">Yes</label>
						</span>
						<span className="active-work-no-radio-field">
							<input type="checkbox" id="no" name="no" value="no" />  <label htmlFor="no">No</label>
						</span>
					</Grid>
					<Grid item xs={4} sm={4} md={4} lg={4} xl={4} className="rehire-container">
						<span className="heading-label">Date of Rehire: </span>
						<span className="textfield-container">
							<TextField
								className="date-field"
								id="text-field"
								variant="standard"
								placeholder="MM"
								name="month"
								style={{
									width: "30px",
									borderRadius: 50
								}}
							/>
						</span>
						/
						<span className="textfield-container">
							<TextField
								className="date-field"
								id="text-field"
								variant="standard"
								placeholder="DD"
								name="day"
								style={{
									marginLeft: "3px",
									width: "30px",
									borderRadius: 50
								}}
							/>
						</span>
						/
						<span className="textfield-container">
							<TextField
								className="date-field"
								id="text-field"
								variant="standard"
								placeholder="YYYY"
								name="year"
								style={{
									marginLeft: "3px",
									width: "50px",
									borderRadius: 50
								}}
							/>
						</span>
					</Grid>
				</Grid>
			</div>
		</div>
	);
};

export default EmployerSection;
